// extracted by mini-css-extract-plugin
module.exports = {"stunningSection":"stunningQuality_stunningSection__2CdG-","nightMode":"stunningQuality_nightMode__3fUt2"};